import { Button, Icon, Select } from '@pwc/pwc-deals-ui';
import { Constants } from '@pwc/pwc-deals-web-common';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  confirmButtonClicked,
  updateTerritory,
} from '../../features/project/projectInitSlice';
import {
  getTerritory,
  territoryConfigObjects,
} from '../helpers/projectInitUtil';
import { PROJECT_INIT_PLATFORM } from '../constants/ProjetctInit';
import { createProjectPagePath } from '../services/urlService';
import './AddProjectModal.scss';

const AddProjectModal = ({ showModal, handleClose }) => {
  const territories = territoryConfigObjects();
  const defaultTerritory = territories.find(
    (territory) => territory.isDefault === true
  );
  const [selectedTerritory, setSelectedTerritory] = useState(defaultTerritory);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const data = territories.map((territory) => {
    return {
      value: territory.territoryCode,
      label: territory.territoryName,
      isDefault: territory.isDefault,
      defaultCurrency: territory.defaultCurrency,
      features: territory.features,
    };
  });
  const platform = selectedTerritory
    ? selectedTerritory.features[0].configurations[0].key
    : '';
  const link = process.env.REACT_APP_DS_CREATE_URL;
  const linkDTP = process.env.REACT_APP_DTP_CREATE_URL;
  const linkText = selectedTerritory
    ? selectedTerritory.features[0].configurations[0].Display
    : '';
  let platformText = PROJECT_INIT_PLATFORM.JUNCTION;

  if (platform === PROJECT_INIT_PLATFORM.DTP) {
    platformText = 'Deals Technology Platform (DTP)';
  } else if (platform === PROJECT_INIT_PLATFORM.DIGITAL_START) {
    platformText = 'Digital Start';
  }

  const handleChange = (event) => {
    const updatedTerritory = getTerritory(territories, event.target.value);
    dispatch(updateTerritory(updatedTerritory));
    setSelectedTerritory(updatedTerritory);
  };

  const handleClick = () => {
    dispatch(confirmButtonClicked(true));
    dispatch(updateTerritory(selectedTerritory));
    handleClose(false);
  };

  return (
    <Modal
      dialogClassName="add-project-modal"
      show={showModal}
      onHide={() => handleClose(false)}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <h3>{t('selectTerritory')}</h3>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <>
          <br />
          <Select
            basic
            style={{ width: 'calc(var(--s25) * 4)' }}
            options={data}
            omitEmpty
            onChange={handleChange}
            value={selectedTerritory.territoryCode}
            helperIconColor="orange"
          />
        </>
        <p className="description">
          <p>
            {t('projectsbasedIn')}{' '}
            {selectedTerritory.territoryCode ===
              Constants.TERRITORY_CODES.UNITED_STATES ||
            selectedTerritory.territoryCode ===
              Constants.TERRITORY_CODES.UNITED_KINGDOM
              ? 'the '
              : ''}
            {selectedTerritory.territoryName} {t('createdAndManagedIn')}{' '}
            {platformText}. {t('returnToJunctionAndRefresh')}
          </p>
          <p>
            <b>{t('projectTakeFewMomentsToAppear')}</b>
          </p>
        </p>
      </Modal.Body>
      <br />
      <Modal.Footer>
        {selectedTerritory && platform !== PROJECT_INIT_PLATFORM.JUNCTION && (
          <a
            className="add-project-modal"
            target="_blank"
            rel="noopener noreferrer"
            href={
              selectedTerritory.territoryCode ===
              Constants.TERRITORY_CODES.GERMANY
                ? linkDTP
                : link
            }
          >
            <Button type="button" onClick={handleClick}>
              {linkText}
              <span className="button-icon">
                <Icon name="box-arrow-up-right" width="16" />
              </span>
            </Button>
          </a>
        )}
        {selectedTerritory && platform === PROJECT_INIT_PLATFORM.JUNCTION && (
          <Link to={createProjectPagePath}>
            <Button type="button" onClick={handleClick}>
              {linkText}
            </Button>
          </Link>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default AddProjectModal;
